const TransactionGridContainer = ({ children, title }) => {
  return (
    <div className="pt-4">
      <h5 className="border-b-2 border-b-bkg2/70 py-2 pl-10 text-text-1/75 ">
        {title}
      </h5>
      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {children}
      </div>
    </div>
  );
};

export default TransactionGridContainer;
